module.exports = __webpack_public_path__ + "static/media/icon-twitter.80314308.svg";